"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkRedirects = exports.singleRedirects = void 0;
const single_redirects_json_1 = __importDefault(require("./single_redirects.json"));
const prod_ca_en_121_json_1 = __importDefault(require("./prod_ca_en_121.json"));
const prod_ca_fr_121_json_1 = __importDefault(require("./prod_ca_fr_121.json"));
const prod_ie_121_json_1 = __importDefault(require("./prod_ie_121.json"));
const prod_ie_ecomm_feds_1_json_1 = __importDefault(require("./prod_ie_ecomm_feds_1.json"));
const prod_outlet_121_json_1 = __importDefault(require("./prod_outlet_121.json"));
const prod_uk_121_json_1 = __importDefault(require("./prod_uk_121.json"));
const prod_uk_ecomm_feds_1_json_1 = __importDefault(require("./prod_uk_ecomm_feds_1.json"));
const prod_us_121_json_1 = __importDefault(require("./prod_us_121.json"));
const prod_us_ca_ecomm_feds_1_json_1 = __importDefault(require("./prod_us_ca_ecomm_feds_1.json"));
const roe_and_europe_business_devs_json_1 = __importDefault(require("./roe_and_europe_business_devs.json"));
const bulkRedirects = [prod_ca_en_121_json_1.default, prod_ca_fr_121_json_1.default, prod_ie_121_json_1.default, prod_ie_ecomm_feds_1_json_1.default, prod_outlet_121_json_1.default, prod_uk_121_json_1.default, prod_uk_ecomm_feds_1_json_1.default, prod_us_121_json_1.default, prod_us_ca_ecomm_feds_1_json_1.default, roe_and_europe_business_devs_json_1.default].flat();
exports.bulkRedirects = bulkRedirects;
const singleRedirects = single_redirects_json_1.default;
exports.singleRedirects = singleRedirects;
//# sourceMappingURL=index.js.map